/* refonte-page.js - genere depuis CLEAN-TWIN-PAGE.html - NE PAS EDITER A LA MAIN */
(function(){
  var RF = document.getElementById('rf-page') || document;
  function RFid(id){ return RF.querySelector('#' + id); }

  document.documentElement.classList.add('js');
  var rm = matchMedia('(prefers-reduced-motion: reduce)').matches;

  function showAll(){
    RF.querySelectorAll('[data-rv]').forEach(function(n){ n.classList.add('on'); });
  }

  /* 1. Reveal au scroll */
  var io = new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('on'); io.unobserve(e.target); } });
  }, {threshold:.12, rootMargin:'0px 0px -40px 0px'});
  RF.querySelectorAll('[data-rv]').forEach(function(n){ io.observe(n); });

  /* Filet de sécurité : onglet caché ou IO inactif, on n'ampute jamais le contenu */
  if(rm || document.visibilityState === 'hidden') showAll();
  addEventListener('visibilitychange', function(){ if(document.visibilityState === 'hidden') showAll(); });
  setTimeout(function(){
    var last = RF.querySelectorAll('[data-rv]');
    if(last.length && !last[0].classList.contains('on')) showAll();
  }, 3000);

  /* 2. Sommaire : section active */
  var links = {}, secs = [];
  RF.querySelectorAll('.toc a').forEach(function(a){
    var id = a.getAttribute('href').slice(1), s = RFid(id);
    if(s){ links[id] = a; secs.push(s); }
  });
  if(secs.length){
    var io2 = new IntersectionObserver(function(es){
      es.forEach(function(e){
        var a = links[e.target.id];
        if(!a) return;
        if(e.isIntersecting){
          for(var k in links) links[k].classList.remove('on');
          a.classList.add('on');
        }
      });
    }, {rootMargin:'-40% 0px -55% 0px'});
    secs.forEach(function(s){ io2.observe(s); });
  }

  /* 3. Spotlight curseur de l'en-tête (desktop, hors reduced-motion) */
  var phd = RFid('phd');
  if(phd && !rm && matchMedia('(hover: hover)').matches){
    phd.classList.add('spot');
    var raf=0, x=50, y=28;
    phd.addEventListener('mousemove', function(e){
      var r=phd.getBoundingClientRect();
      x=((e.clientX-r.left)/r.width)*100; y=((e.clientY-r.top)/r.height)*100;
      if(!raf) raf=requestAnimationFrame(function(){ phd.style.setProperty('--mx',x+'%'); phd.style.setProperty('--my',y+'%'); raf=0; });
    }, {passive:true});
  }

  /* 4. Sommaire genere depuis le contenu reel de la page ({{ page.content }}) */
  var zone = RFid('rf-content'), toc = RF.querySelector('.toc'),
      bar = toc && toc.querySelector('.toc__in');
  if(zone && bar){
    var hs = [].slice.call(zone.querySelectorAll('h2')).filter(function(h){
      return (h.textContent || '').trim();
    }), n = 0;
    hs.forEach(function(h){
      n++;
      if(!h.id) h.id = 'rf-s' + n;
      var a = document.createElement('a');
      a.setAttribute('href', '#' + h.id);
      a.textContent = h.textContent.trim();
      bar.appendChild(a);
    });
    if(n >= 2) toc.removeAttribute('hidden');
  }

  /* 5. Confort de lecture : tableaux scrollables, images allegees */
  if(zone){
    [].slice.call(zone.querySelectorAll('table')).forEach(function(t){
      if(t.parentNode && t.parentNode.classList.contains('cmp')) return;
      var w = document.createElement('div');
      w.className = 'cmp';
      t.parentNode.insertBefore(w, t);
      w.appendChild(t);
    });
    [].slice.call(zone.querySelectorAll('img')).forEach(function(i){
      i.setAttribute('loading', 'lazy'); i.setAttribute('decoding', 'async');
    });
  }

  /* 6. Sommaire actif : relance apres generation (les cibles n'existaient pas plus haut) */
  var tl = [].slice.call(RF.querySelectorAll('.toc a[href^="#"]'));
  if(tl.length){
    var tmap = {}, tt = [];
    tl.forEach(function(a){
      var el = RFid(a.getAttribute('href').slice(1));
      if(el){ tmap[el.id] = a; tt.push(el); }
    });
    if(tt.length){
      var io4 = new IntersectionObserver(function(es){
        es.forEach(function(e){
          if(!e.isIntersecting) return;
          tl.forEach(function(a){ a.classList.remove('on'); });
          if(tmap[e.target.id]) tmap[e.target.id].classList.add('on');
        });
      }, {rootMargin:'-90px 0px -70% 0px', threshold:0});
      tt.forEach(function(t){ io4.observe(t); });
    }
  }
})();

/* menu mobile */
(function(){
  var hd = document.querySelector('[id^="rf-"] .hd') || document.querySelector('.hd');
  if(!hd) return;
  var b = hd.querySelector('.brg');
  if(!b) return;
  b.addEventListener('click', function(){
    var open = hd.classList.toggle('is-open');
    b.setAttribute('aria-expanded', String(open));
    b.setAttribute('aria-label', open ? 'Chiudi il menu' : 'Apri il menu');
  });
  hd.querySelectorAll('.nav a').forEach(function(a){
    a.addEventListener('click', function(){
      hd.classList.remove('is-open'); b.setAttribute('aria-expanded','false');
    });
  });
  document.addEventListener('click', function(e){
    if(hd.classList.contains('is-open') && !hd.contains(e.target)){
      hd.classList.remove('is-open'); b.setAttribute('aria-expanded','false');
    }
  });
})();
